export const failureHash = {
    ACCOUNT_CREDENTIAL_NOT_CONNECTED: "API__EP__PAGE_CONFIG__ACCOUNT_CREDENTIAL_NOT_CONNECTED",
    ACCOUNT_CREDENTIAL_RECONNECT_REQUIRED: "API__EP__PAGE_CONFIG__ACCOUNT_CREDENTIAL_RECONNECT_REQUIRED",
    ACTION_BLOCKED: "API__EP__PAGE_CONFIG__ACTION_BLOCKED",
    ORGANIZATION_PAGE_CONFIG_DESTROY_FORBIDDEN: "API__EP__PAGE_CONFIG__ORGANIZATION_PAGE_CONFIG_DESTROY_FORBIDDEN",
    PAGECONFIG_COPY_FORBIDDEN: "API__EP__PAGE_CONFIG__PAGECONFIG_COPY_FORBIDDEN",
    PAGECONFIG_MANAGE_CONFLICT: "API__EP__PAGE_CONFIG__PAGECONFIG_MANAGE_CONFLICT",
    PAGE_CONFIG_NAME_ALREADY_EXISTS: "API__EP__PAGE_CONFIG__PAGE_CONFIG_NAME_ALREADY_EXISTS",
    TRANSFER_PAGE_CONFIG_INVALID: "API__EP__PAGE_CONFIG__PAGE_CONFIG_TRANSFER_PAGE_CONFIG_INVALID",
    UNKNOWN: "API__EP__PAGE_CONFIG__UNKNOWN", // Unknown error has occurred.
};
//# sourceMappingURL=pageconfig.static.js.map